// export default checkboxButton;
import './Checkbox.scss';

import React from 'react';

import removeWhiteSpace from '../../constants/removeSpace';
import {ADMIN_ROLE} from '../../constants/global';
import '../SmartDisplay/SmartDisplay.scss';

const Checkbox = ({org_rol, children, readOnly, halfInput, checkboxId, CheckBoxRequired, checkboxName, checkboxValue, checkboxInput, onChangecheckboxValue, isDisabled=false, checkboxClass=''}) => (
  <div id={removeWhiteSpace(`${checkboxId}`)} className={`wrapanywhere lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
    <label htmlFor={removeWhiteSpace(`checkbox-${checkboxId}`)} className={checkboxClass}>
      <input
        id={removeWhiteSpace(`checkbox-${checkboxId}`)}
        className='inputClasstest'
        type='checkbox'
        required={CheckBoxRequired}
        disabled={readOnly || isDisabled}
        aria-readonly={readOnly}
        name={checkboxName}
        data-testid='checkboxid'
        onChange={onChangecheckboxValue}
        value={checkboxValue}
        checked={checkboxInput}
      />
      <span className='spanWidth' style={isDisabled?{color:'lightgray'}:{color:'black'}}>{checkboxValue}</span>
    </label>
  </div>
);

export default Checkbox;